<template>
  <div>
    <template v-if="addDiscount">
      <span class="price-old">
        {{ formatCurrency(total,currency) }}
      </span>

      <span class="price">
        {{ formatCurrency(totalWithNewPrice,currency) }}
      </span>
    </template>

    <template v-else>
      <span>
        {{ formatCurrency(total,currency) }}
      </span>
    </template>
  </div>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api';
import useNumberFormatter from '@/compositions/useNumberFormatter';

export default {
  name: 'PaymentPeriodPrice',
  props: {
    period: {
      type: Object,
      required: true,
    },
    plan: {
      type: Object,
      required: true,
    },
    newPrice: {
      type: Number,
      required: false,
    },
    addDiscount: {
      type: Number,
      required: false,
    },
  },
  setup(props) {
    const { formatCurrency } = useNumberFormatter();
    const { period, plan, newPrice } = toRefs(props);

    const price = computed(() => {
      return ((100 - period.value.discountPercent) / 100) * plan.value.price.value;
    });

    const total = computed(() => price.value * period.value.duration);
    const totalWithNewPrice = computed(() => newPrice.value * period.value.duration);

    return {
      total,
      totalWithNewPrice,
      currency: computed(() => plan.value.price.currency),
      formatCurrency,
    };
  },
};
</script>

<style scoped>
.price-old {
  text-decoration: line-through;
  color: rgba(33, 33, 33, 0.5);
  text-decoration-color: rgba(33, 33, 33, 0.5);
  margin-right: 3px;
}
</style>
